import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-lg leading-7 font-medium text-black pb-6" }, " Schedule when the workflow should trigger. Select a schedule type: ", -1)
const _hoisted_3 = { class: "flex flex-col gap-y-3" }

import { Component } from "vue"
import DelayTypeCard from "@/components/workflows/sidebar/action/delay/DelayTypeCard.vue"
import CalendarDateScheduleComponent from "@/components/workflows/sidebar/trigger/schedule/CalendarDateScheduleComponent.vue"
import WeekDaysScheduleComponent from "@/components/workflows/sidebar/trigger/schedule/WeekDaysScheduleComponent.vue"
import TimeOfDayScheduleComponent from "@/components/workflows/sidebar/trigger/schedule/TimeOfDayScheduleComponent.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'ScheduleTriggerSidebar',
  emits: ["changeAction"],
  setup(__props, { emit: __emit }) {

const emit = __emit

const scheduleTypes = [
    { title: "Calendar date", example: "Trigger in 03/21/2023 at 12:00 PM", component: CalendarDateScheduleComponent },
    { title: "Days of week", example: "Trigger every Monday", component: WeekDaysScheduleComponent },
    { title: "Time of day", example: "Trigger at 12:00 PM EST", component: TimeOfDayScheduleComponent },
]

function selectScheduleType(sidebarComponent: Component) {
    emit("changeAction", {
        sidebarComponent,
    })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(scheduleTypes, (schedule) => {
        return _createVNode(DelayTypeCard, {
          key: schedule.title,
          title: schedule.title,
          example: schedule.example,
          onClick: ($event: any) => (selectScheduleType(schedule.component))
        }, null, 8, ["title", "example", "onClick"])
      }), 64))
    ])
  ]))
}
}

})